import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/home_transportation.webp'
import _imports_1 from '../assets/home_Government.webp'
import _imports_2 from '../assets/home_Retail.webp'
import _imports_3 from '../assets/home_Education.webp'
import _imports_4 from '../assets/home_Healthcare.webp'
import _imports_5 from '../assets/home_Hospitality.webp'
import _imports_6 from '../assets/Holistic Integration_BG.webp'
import _imports_7 from '../assets/gif/Why Choose wove - gif 1.webp'
import _imports_8 from '../assets/Holistic Integration_BG.webp'
import _imports_9 from '../assets/gif/Why Choose wove - gif 2.webp'
import _imports_10 from '../assets/Holistic Integration_BG.webp'
import _imports_11 from '../assets/gif/Why Choose wove - gif 3.webp'
import _imports_12 from '../assets/Holistic Integration_BG.webp'
import _imports_13 from '../assets/gif/Why Choose wove - gif 4.webp'


const _withScopeId = n => (_pushScopeId("data-v-7229e418"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "home",
  class: "home"
}
const _hoisted_2 = { class: "home-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-header-mask" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-header-title" }, "Weave Your Vision", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-header-text tMgt16 tMgb16" }, [
  /*#__PURE__*/_createTextVNode(" At Wove Technologies, we deliver customized solutions, including software and hardware, all designed to empower"),
  /*#__PURE__*/_createElementVNode("br", { class: "home-header-text-br" }),
  /*#__PURE__*/_createTextVNode(" your business and drive it toward success. ")
], -1))
const _hoisted_6 = { class: "home-industries" }
const _hoisted_7 = { class: "home-industries-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-industries-title" }, "Industries we work with", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "home-industries-item pointer",
  href: "/infrastructure"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "home-industries-img"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "home-industries-text" }, "Transportation")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "home-industries-item pointer",
  href: "/governmentAndEnterpriseOffice"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "home-industries-img"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "home-industries-text" }, [
    /*#__PURE__*/_createTextVNode("Government and "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Enterprise Office")
  ])
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "home-industries-item pointer",
  href: "/retail"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "home-industries-img"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "home-industries-text" }, "Retail")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "home-industries-item pointer",
  href: "/education"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "home-industries-img"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "home-industries-text" }, "Education")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "home-industries-item pointer",
  href: "/healthcare"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    class: "home-industries-img"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "home-industries-text" }, "Healthcare")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "home-industries-item pointer",
  href: "/hospitality"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    class: "home-industries-img"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "home-industries-text" }, "Hospitality")
], -1))
const _hoisted_15 = { class: "home-partner" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-partner-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "home-partner-title" }, [
    /*#__PURE__*/_createTextVNode("Partner With A Reliable "),
    /*#__PURE__*/_createElementVNode("br", { class: "home-partner-title-br" }),
    /*#__PURE__*/_createTextVNode("Technology Company")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "home-partner-text" }, " Reach out for tailored solutions to elevate your operations. ")
], -1))
const _hoisted_17 = { class: "home-chooseWove" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-chooseWove-title" }, "Why Choose Wove", -1))
const _hoisted_19 = { class: "home-chooseWove-container" }
const _hoisted_20 = { class: "home-chooseWove-item-box" }
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"home-chooseWove-item\" data-v-7229e418><img src=\"" + _imports_6 + "\" class=\"home-chooseWove-img-bg\" data-v-7229e418><img src=\"" + _imports_7 + "\" class=\"home-chooseWove-img\" data-v-7229e418></div><div class=\"home-chooseWove-item\" data-v-7229e418><img src=\"" + _imports_8 + "\" class=\"home-chooseWove-img-bg\" data-v-7229e418><img src=\"" + _imports_9 + "\" class=\"home-chooseWove-img\" data-v-7229e418></div>", 2)
const _hoisted_23 = { class: "home-chooseWove-item-box" }
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"home-chooseWove-item\" data-v-7229e418><img src=\"" + _imports_10 + "\" class=\"home-chooseWove-img-bg\" data-v-7229e418><img src=\"" + _imports_11 + "\" class=\"home-chooseWove-img\" data-v-7229e418></div><div class=\"home-chooseWove-item\" data-v-7229e418><img src=\"" + _imports_12 + "\" class=\"home-chooseWove-img-bg\" data-v-7229e418><img src=\"" + _imports_13 + "\" class=\"home-chooseWove-img\" data-v-7229e418></div>", 2)
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<a class=\"home-SoftwareSolutions\" href=\"/software\" data-v-7229e418><div class=\"home-SoftwareSolutions-img-backcolor\" data-v-7229e418></div><div class=\"home-SoftwareSolutions-img\" data-v-7229e418></div><div class=\"home-SoftwareSolutions-title\" data-v-7229e418>Software Solutions &gt;</div><div class=\"home-SoftwareSolutions-text\" data-v-7229e418> From intelligent data analytics to user-friendly management platforms, explore a range of solutions designed to transform your digital landscape. </div></a><div class=\"home-SoftwareSolutions home-SoftwareSolutions-hardware\" data-v-7229e418><a class=\"home-SoftwareSolutions-box\" href=\"/hardware\" data-v-7229e418><div class=\"home-HardwareInnovations-img\" data-v-7229e418></div><div class=\"home-SoftwareSolutions-box-title\" data-v-7229e418>Hardware Innovations &gt;</div><div class=\"home-SoftwareSolutions-box-text\" data-v-7229e418> Professional Display, Energy Management System Architecture, Industrial Grade IoT Edge Computer, and more. </div></a><a class=\"home-SoftwareSolutions-box colorBlack\" href=\"/meter\" data-v-7229e418><div class=\"home-IntelligentWattHourMeter-img\" data-v-7229e418></div><div class=\"home-SoftwareSolutions-box-title\" data-v-7229e418>Intelligent Watt-Hour Meter &gt;</div><div class=\"home-SoftwareSolutions-box-text\" data-v-7229e418> A smart, accurate, and stable solution designed to meet your energy management needs with our Power Meters. </div></a></div><a class=\"home-SoftwareSolutions\" href=\"/iot\" data-v-7229e418><div class=\"home-SoftwareSolutions-img home-IoT-img\" data-v-7229e418></div><div class=\"home-SoftwareSolutions-title home-IoT-title\" data-v-7229e418>IoT &gt;</div><div class=\"home-SoftwareSolutions-text home-IoT-text\" data-v-7229e418> Advanced technologies like IoT, LoRaWAN® Gateways, and various sensors for an intelligent and efficient ecosystem. </div></a>", 3)
const _hoisted_29 = { class: "home-CustomizedOfferings" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-CustomizedOfferings-title" }, "Customized Offerings", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-CustomizedOfferings-text" }, " Share your vision, and we'll turn it into reality by providing tailored solutions to meet your specific requirements. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactUsButton = _resolveComponent("ContactUsButton")!
  const _component_HomeCarousel = _resolveComponent("HomeCarousel")!
  const _component_ScrollBlock = _resolveComponent("ScrollBlock")!
  const _component_HomeChooseCard = _resolveComponent("HomeChooseCard")!
  const _component_ContactForm = _resolveComponent("ContactForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createVNode(_component_ContactUsButton, {
        class: "home-header-button",
        color: "black",
        routeInfo: { path:'/about' }
      })
    ]),
    _createVNode(_component_HomeCarousel),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_ScrollBlock, {
          scrollId: "scroll1",
          blockWidth: _ctx.blockWidth,
          itemNum: 6,
          canScroll: _ctx.blockWidth !== 540,
          showButton: _ctx.blockWidth === 540
        }, {
          content: _withCtx(() => [
            _hoisted_9,
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            _hoisted_13,
            _hoisted_14
          ]),
          _: 1
        }, 8, ["blockWidth", "canScroll", "showButton"])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      _createVNode(_component_ContactUsButton, {
        color: "black",
        class: "home-partner-button",
        routeInfo: { path:'/contactUs' }
      })
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_HomeChooseCard, {
            gifKey: "home_gif_1",
            src: require('../assets/gif/Why Choose wove - gif 1.webm'),
            videoOptions: {
                          playbackRate: 1.5,
                          startTime: 0.7,
                          pauseTime: 1.7,
                          restartTime: 3.3
                      },
            title: "Holistic Integration",
            text: "Seamlessly blend hardware and software for comprehensive solutions."
          }, null, 8, ["src"]),
          _createVNode(_component_HomeChooseCard, {
            gifKey: "home_gif_2",
            src: require('../assets/gif/Why Choose wove - gif 2.webm'),
            videoOptions: {
                          playbackRate: 1.5,
                          startTime: 0.3,
                          pauseTime: 0.7,
                          restartTime: 2.5
                      },
            title: "Future-Ready Connectivity",
            text: "Stay ahead with cutting-edge solutions shaping the future."
          }, null, 8, ["src"]),
          _hoisted_21
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_HomeChooseCard, {
            gifKey: "home_gif_3",
            src: require('../assets/gif/Why Choose wove - gif 3.webm'),
            videoOptions: {
                          playbackRate: 1.3,
                          startTime: 0.1,
                          pauseTime: 1.3,
                          restartTime: 1.8,
                      },
            title: "Efficiency Redefined",
            text: "Streamlined processes for enhanced performance and productivity."
          }, null, 8, ["src"]),
          _createVNode(_component_HomeChooseCard, {
            gifKey: "home_gif_4",
            src: require('../assets/gif/Why Choose wove - gif 4.webm'),
            videoOptions: {
                          playbackRate: 1.3,
                          startTime: 0.35,
                          pauseTime: 1.4,
                          restartTime: 2.35
                      },
            title: "Client-Centric Approach",
            text: "Tailored services to meet your unique needs and goals."
          }, null, 8, ["src"]),
          _hoisted_24
        ])
      ])
    ]),
    _hoisted_26,
    _createElementVNode("div", _hoisted_29, [
      _hoisted_30,
      _hoisted_31,
      _createVNode(_component_ContactForm)
    ])
  ]))
}